import { AxiosClient } from '@/app/shared/services';
import i18n from '@/i18n/i18n';

const state = {
    applications: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
    application: {
    },
    isOpen: false,
    newApplication: false,
};

const getters = {
    GET_APPLICATIONS_FOR_USER: (state) => {
        const applications = [];
        state.applications.data.forEach((item) => {
            const application = {};
            application.id = item.id;
            application.sum = item.sum;
            application.bet = item.bet;
            application.days = item.days;

            application.payout_date = new Date(item.deal.postbacks[0].created_at);
            application.maturity_date = new Date(new Date(item.deal.postbacks[0].created_at).setDate(application.payout_date.getDate() + item.days));
            application.payout_date_show = application.payout_date.toLocaleDateString();
            application.maturity_date_show = application.maturity_date.toLocaleDateString();

            application.status = item.deal.postbacks[0].status;
            switch (application.status) {
            case 'pending':
                const msg = i18n.t('deals_status.pending');
                application.status_show = msg;
                application.payout_date_show = '-';
                application.maturity_date_show = '-';
                application.button_show = false;
                break;
            case 'approved':
                application.status_show = i18n.t('deals_status.approved');
                application.payout_date_show = application.payout_date.toLocaleDateString();
                application.maturity_date_show = application.maturity_date.toLocaleDateString();
                application.button_show = true;
                break;
            case 'rejected':
                application.status_show = i18n.t('deals_status.rejected');
                application.payout_date_show = '-';
                application.maturity_date_show = '-';
                application.button_show = false;
                break;
            }
            application.payout_date = application.payout_date.getTime();
            application.maturity_date = application.maturity_date.getTime();
            application.img_path = item.deal.offer.img_path;
            application.url = item.deal.offer.affiliate_url;
            applications.push(application);
        });
        return applications;
    },
    APPLICATIONS_PENDING: (state) => {
        var applications = [];
        state.applications.data.forEach((item) => {
            if (item.deal.postbacks[0].status == 'pending') {
                const application = {};
                application.id = item.id;
                application.sum = item.sum;
                application.bet = item.bet;
                application.days = item.days;

                application.payout_date = new Date(item.deal.postbacks[0].created_at);
                application.maturity_date = new Date(new Date(item.deal.postbacks[0].created_at).setDate(application.payout_date.getDate() + item.days));
                application.payout_date_show = application.payout_date.toLocaleDateString();
                application.maturity_date_show = application.maturity_date.toLocaleDateString();

                application.status = item.deal.postbacks[0].status;
                const msg = i18n.t('deals_status.pending');
                application.status_show = msg;
                // application.payout_date_show = '-';
                application.maturity_date_show = '-';
                application.button_show = false;
                application.payout_date = application.payout_date.getTime();
                application.maturity_date = application.maturity_date.getTime();
                application.img_path = item.deal.offer.img_path;
                application.url = item.deal.offer.affiliate_url;
                applications.push(application);
            }
        });
        return applications;
    },
    APPLICATIONS_APPROVED: (state) => {
        var applications = [];
        state.applications.data.forEach((item) => {
            if (item.deal.postbacks[0].status == 'approved') {
                const application = {};
                application.id = item.id;
                application.sum = item.sum;
                application.bet = item.bet;
                application.days = item.days;

                application.payout_date = new Date(item.deal.postbacks[0].created_at);
                application.maturity_date = new Date(new Date(item.deal.postbacks[0].created_at).setDate(application.payout_date.getDate() + item.days));
                application.payout_date_show = application.payout_date.toLocaleDateString();
                application.maturity_date_show = application.maturity_date.toLocaleDateString();

                application.status = item.deal.postbacks[0].status;
                application.status_show = i18n.t('deals_status.approved');
                application.payout_date_show = application.payout_date.toLocaleDateString();
                application.maturity_date_show = application.maturity_date.toLocaleDateString();
                application.button_show = true;
                application.payout_date = application.payout_date.getTime();
                application.maturity_date = application.maturity_date.getTime();
                application.img_path = item.deal.offer.img_path;
                application.url = item.deal.offer.affiliate_url;
                applications.push(application);
            }
        });
        return applications;
    },
    IS_APPLICATION_MODAL_OPENED: state => state.isOpen,
    IS_NEW_APPLICATION_MODAL_OPENED: state => state.newApplication,
    GET_APPLICATION_FOR_MODAL: state => state.application,
};

const mutations = {
    SET_APPLICATIONS: (state, applications) => state.applications.data = applications,
    SET_APPLICATIONS_LOADING: (state, isLoading) => state.applications.isLoading = isLoading,
    SET_APPLICATIONS_LOADING_SUCCESS: (state, isSuccess) => state.applications.isSuccess = isSuccess,
    SET_NEW_APPLICATION_SETTINGS: (state, data) => {
        state.applications.data[state.applications.data.findIndex(appl => appl.id == data.id)].days = data.days;
        state.applications.data[state.applications.data.findIndex(appl => appl.id == data.id)].bet = data.bet;
        state.applications.data[state.applications.data.findIndex(appl => appl.id == data.id)].sum = data.sum;
    },
    SET_APPLICATION_MODAL_IS_OPEN: (state, isOpen) => state.isOpen = isOpen,
    SET_NEW_APPLICATION_MODAL_IS_OPEN: (state, isOpen) => state.newApplication = isOpen,
    SET_APPLICATION_MODAL_DATA: (state, application) => state.application = application,
};

const actions = {
    GET_APPLICATIONS_BY_PROFILE: (context) => {
        context.commit('SET_APPLICATIONS_LOADING', true);
        return new Promise((resolve, reject) => {
          AxiosClient.get('/applications/get_applications')
            .then((data) => {
              context.commit('SET_APPLICATIONS', data.data);
              context.commit('SET_APPLICATIONS_LOADING_SUCCESS', true);
              resolve();
            })
            .catch((error) => {
              reject(error);
            })
            .finally(() => {
              context.commit('SET_APPLICATIONS_LOADING', false);
            });
        });
      },
    CHANGE_APPLICATION: (context, data) => {
        context.commit('SET_APPLICATIONS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/applications/update_application', data)
            .then(() => {
                resolve();
                context.commit('SET_NEW_APPLICATION_SETTINGS', data);
            })
            .catch(() => {
                reject();
            })
            .finally(() => {
                context.commit('SET_APPLICATIONS_LOADING', false);
            });
        });
    },
    GET_NEW_APPLICATIONS: context => new Promise((resolve, reject) => {
        AxiosClient.get('/applications/get_new_application')
            .then((data) => {
                if (data.data) {
                    context.commit('SET_NEW_APPLICATION_MODAL_IS_OPEN', true);
                }
            })
            .catch((error) => {
                reject(error);
            });
    }),
    OPEN_APPLICATION_MODAL: (context, isOpen) => context.commit('SET_APPLICATION_MODAL_IS_OPEN', isOpen),
    CHANGE_APPLICATION_MODAL_DATA: (context, application) => context.commit('SET_APPLICATION_MODAL_DATA', application),
    OPEN_NEW_APPLICATION_MODAL: (context, isOpen) => context.commit('SET_NEW_APPLICATION_MODAL_IS_OPEN', isOpen),
};

export default {
    state,
    getters,
    mutations,
    actions,
};